/* eslint-disable */
const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
  const token = localStorage.getItem("token");
  const headers = new Headers(init.headers || {});
  if (token) {
    headers.set("Authorization", `Bearer ${token.replace(/['"]+/g, "")}`);
  }

  const modifiedInit = {
    ...init,
    headers
  };

  try {
    const response = await originalFetch(input, modifiedInit);
    return response;
  } catch (error) {
    console.error("Errore nella richiesta:", error);
    throw error;
  }
};
